import { Link } from "react-router-dom";
import { FdaDisclaimer, ShippingRestriction } from "@/components/Compliance";

export const Footer = () => {
  return (
    <footer className="marble-band mt-24 border-t border-black/10">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-4">
        <div>
          <span className="text-xl font-black tracking-tight text-[#2b2520]">
            THE GOOD<span className="gold-text"> LIFE</span>
          </span>
          <p className="mt-4 max-w-xs text-sm text-neutral-600">
            Flower, prerolls, and blunts, shipped discreetly to your door.
          </p>
          <p className="mt-4 text-xs text-neutral-500">
            Halegalcannabis@gmail.com · 828-424-4828
            <br />
            Asheville, NC
          </p>
        </div>
        <div>
          <p className="overline mb-4">Shop</p>
          <ul className="space-y-2 text-sm text-neutral-600">
            <li><Link to="/shop?c=flower" className="hover:text-[#a06d34]">Flower</Link></li>
            <li><Link to="/shop?c=blunt" className="hover:text-[#a06d34]">Blunts</Link></li>
            <li><Link to="/shop?c=concentrate" className="hover:text-[#a06d34]">Concentrates</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-4">Policies</p>
          <ul className="space-y-2 text-sm text-neutral-600">
            <li><Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-[#a06d34]">Privacy Policy</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-refund" className="hover:text-[#a06d34]">Refund Policy</Link></li>
            <li><Link to="/sales-policy" data-testid="footer-sales" className="hover:text-[#a06d34]">Sales Policy</Link></li>
            <li><Link to="/compliance-policy" data-testid="footer-compliance" className="hover:text-[#a06d34]">Compliance Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-[#a06d34]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-4">Compliance</p>
          <p className="text-sm text-neutral-600">
            You must be 21 or older to purchase. Valid government ID and age
            verification required at signup.
          </p>
        </div>
      </div>
      <div className="border-t border-black/10 bg-[#f2ece1]/60" data-testid="footer-compliance-band">
        <div className="mx-auto max-w-7xl space-y-3 px-6 py-8">
          <ShippingRestriction />
          <FdaDisclaimer />
        </div>
      </div>
      <div className="border-t border-black/10 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} The Good Life. All rights reserved.
      </div>
    </footer>
  );
};
